module.exports = __webpack_public_path__ + "static/media/wDark_day.85587aaa.svg";